import ColorStyleContext from "@/lib/providers/color-style-privider";
import { useContext } from "react";

const DynamicFormThankYou = ({text}:{text: any}) => {
    const colorStyle = useContext(ColorStyleContext);
    return (
        <div style={{ color: colorStyle?.headingMain || "#254b7c" }}>
            <h3>{text["thank_you"]}</h3>
        </div>
    );
};

export default DynamicFormThankYou;